import { render, staticRenderFns } from "./OrderShipped.vue?vue&type=template&id=a6075170&scoped=true"
import script from "./OrderShipped.vue?vue&type=script&lang=js"
export * from "./OrderShipped.vue?vue&type=script&lang=js"
import style0 from "./OrderShipped.vue?vue&type=style&index=0&id=a6075170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6075170",
  null
  
)

export default component.exports